<template>
  <div class="news-detail">
    <a-spin :spinning="loading" size="large" style="width:100%;" tip="加载中...">
      <div>
        <div class="top-back-div">
          <a @click="$router.go(-1)" class="top-back">
            <a-icon type="left"/>
            返回</a>
        </div>
<!--        <img-->
<!--          :src="record.attachmentList.filter(item => item.subBizType === '2')&&record.attachmentList.filter(item => item.subBizType === '2').length>0?baseUrl + record.attachmentList.filter(item => item.subBizType === '2')[0].url:''"-->
<!--          class="top-img"/>-->
        <div class="title">{{record.title}}</div>
        <div class="time">{{record.createTime}}</div>
        <div class="html-detail" v-html="record.content"/>
        <div :key="attachment.id" v-for="attachment in attachmentFileList">
          <a @click="_download(attachment)">{{ attachment.name }}</a>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import news from '../../api/news'

  export default {
    name: 'whole',
    components: {},
    data() {
      return {
        baseUrl: process.env.VUE_APP_BASE_URL,
        loading: true,
        record: {},
        attachmentFileList: []
      }
    },
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    filters: {},
    methods: {
      loadData() {
        this.loading = true
        // 如果不存在详情所需数据，则跳转到列表
        if (!sessionStorage.getItem('newsId')) {
          this.$router.push('/home/news')
          return
        }
        news.getNewsDynamic({ id: sessionStorage.getItem('newsId') }).then(res => {
          this.record = res.result
          this.attachmentFileList = this.record.attachmentList.filter(item => item.subBizType === '3')
          setTimeout(() => {
            this.loading = false
          }, 500)
        })
      },
      _download(record) {
        this.$message.info('正在下载，请稍后...')
        location.href = 'http://' + window.location.host + '/base/attachment/downloadAttachment' + '?id=' + record.id
      }
    },
    created() {
      this.loadData()
    }

  }
</script>
<style lang="less">
  .news-detail {
    padding: 0 2.2501rem;

    .top-img {
      width: 6.7502rem;
      height: auto;
      object-fit: cover;
    }

    .time {
      color: #79818d;
      font-size: 0.135rem;
      margin-top: 0.125rem;
      text-align: right;
    }

    .title {
      font-weight: 600;
      color: #191d28;
      font-size: 0.225rem;
      line-height: 0.34rem;
      margin-top: 0.225rem;
      text-align: center;
    }

    .html-detail {
      margin-top: 0.125rem;
    }

    .top-back-div {
      margin-bottom: 0.075rem;

      .top-back {
        font-size: 0.12rem;
      }
    }

    .footer-btn {
      margin-top: 0.3rem;
      text-align: center;

      .reset-btn {
        width: 0.75rem;
        height: 0.3rem;
        margin-left: 0.195rem;
        background-color: rgba(0, 0, 0, 0);
        border-color: rgba(23, 77, 244, 1);
        color: rgba(23, 77, 244, 1);
        font-size: 0.135rem;
      }
    }
  }
</style>
